module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/ppg-400.0e79924dc0fdc8cd.png"+" 400w",
        images: [{path: "https://static.sniffspot.com/packs/img/ppg-400.0e79924dc0fdc8cd.png",width: 400,height: 310}],
        src: "https://static.sniffspot.com/packs/img/ppg-400.0e79924dc0fdc8cd.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/ppg-400.0e79924dc0fdc8cd.png"},
        
        width: 400,
        height: 310
      }